import { ActionReducerMap } from '@ngrx/store';

import {
    profileReducer,
    initialStateType as profileReducerInitialStateType,
} from './reducers/profile.reducer';

import { formInfoReducer } from './reducers/form-info.reducer';
import { estateReducer } from './reducers/estate.reducer';
import {
    appSettingReducer,
    AppSettingReducerType,
} from './reducers/app-setting.reducer';

export type ActionReducerMapType = {
    profileReducer: profileReducerInitialStateType;
    formInfoReducer: any;
    estateReducer;
    appSettingReducer: AppSettingReducerType;
};
export const reducers: ActionReducerMap<ActionReducerMapType> = {
    profileReducer,
    formInfoReducer,
    estateReducer,
    appSettingReducer,
};
